<template>
    <div class="animal">
        <div class="tabBox">
            <div class="tabItem active">Large Animal</div>
            <div class="tabItem">Small Animal</div>
        </div>
        <div class="tabBox2">
            <div class="tabItem2">GI Endoscopy</div>
            <div class="tabItem2">Bronchoscopy</div>
            <div class="tabItem2">ENT Endoscopy</div>
            <div class="tabItem2">Cysto&Urethroscopy</div>
        </div>
        <div class="content">
            <div class="title">GI Endoscopy</div>
            <div class="listBox">
                <div v-for="item in 6" :key="item" class="listItem">
                    <img src="@/assets/index/panda-bear.png" alt="">
                    <div class="name">VET-FHD33</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.animal {
    width: 1200px;
    margin: auto;

    .tabBox {
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #888888;

        .tabItem {
            height: 100px;
            line-height: 100px;
            font-size: 24px;
            color: #000000;
            width: 450px;
            text-align: center;
            cursor: pointer;
        }

        .active{
            position: relative;
            &::after{
                content: '';
                
            }
        }
    }

    .tabBox2 {
        margin-top: 30px;
        display: flex;
        align-items: center;
        gap: 30px;

        .tabItem2 {
            width: 277px;
            height: 155px;
            line-height: 155px;
            text-align: center;
            color: #fff;
            font-size: 22px;
            background-image: url('../../assets/index/panda-bear.png');
        }
    }

    .content {
        margin-top: 120px;

        .title {
            font-size: 30px;
            color: #000000;
            line-height: 30px;
            padding-bottom: 22px;
            border-bottom: 1px solid #888888;
        }

        .listBox {
            margin-top: 52px;
            display: flex;
            flex-wrap: wrap;
            gap: 30px;

            .listItem {
                width: 380px;
                margin-bottom: 60px;

                img {
                    width: 100%;
                    height: 300px;
                }

                .name {
                    text-align: center;
                    margin-top: 28px;
                    text-align: center;
                    font-size: 20px;
                    color: #000000;
                    line-height: 24px;
                }
            }
        }
    }
}

@media screen and (max-width:1200px) {}
</style>